export type ContractTypeCode = 'clt' | 'mei' | 'pj' | 'other';

export interface FiscalFormValues {
  contractType: '' | ContractTypeCode;
  companyDocument: string;
  companyName: string;
  invoiceRequired: boolean;
  invoiceRequiredFrom: string;
  invoiceRequiredUntil: string;
}

const COMPETENCE = /^[0-9]{4}-(0[1-9]|1[0-2])$/;

export function isFiscalProfileIncomplete(values: {
  contractType?: string | null;
  companyDocument?: string | null;
  companyName?: string | null;
}): boolean {
  if (values.contractType !== 'mei' && values.contractType !== 'pj') {
    return false;
  }
  return !values.companyDocument?.trim() || !values.companyName?.trim();
}

export function fiscalIncompleteMessage(values: {
  contractType?: string | null;
  companyDocument?: string | null;
  companyName?: string | null;
}): string | null {
  if (values.contractType !== 'mei' && values.contractType !== 'pj') {
    return null;
  }
  const missing: string[] = [];
  if (!values.companyDocument?.trim()) {
    missing.push('CNPJ');
  }
  if (!values.companyName?.trim()) {
    missing.push('razão social');
  }
  if (missing.length === 0) {
    return null;
  }
  return `Cadastro fiscal incompleto: informe ${missing.join(' e ')}.`;
}

export function fiscalFormError(values: FiscalFormValues): string | null {
  if (values.contractType && !['clt', 'mei', 'pj', 'other'].includes(values.contractType)) {
    return 'Tipo de contrato inválido. Use clt, mei, pj ou other.';
  }
  if (values.invoiceRequiredFrom && !COMPETENCE.test(values.invoiceRequiredFrom)) {
    return 'Competência inicial inválida. Use o formato AAAA-MM.';
  }
  if (values.invoiceRequiredUntil && !COMPETENCE.test(values.invoiceRequiredUntil)) {
    return 'Competência final inválida. Use o formato AAAA-MM.';
  }
  if (values.invoiceRequired && !values.invoiceRequiredFrom) {
    return 'Informe a competência inicial quando a nota fiscal for obrigatória.';
  }
  if (values.invoiceRequiredUntil && !values.invoiceRequiredFrom) {
    return 'Informe a competência inicial antes da competência final.';
  }
  if (
    values.invoiceRequiredFrom &&
    values.invoiceRequiredUntil &&
    values.invoiceRequiredUntil < values.invoiceRequiredFrom
  ) {
    return 'A competência final não pode ser anterior à inicial.';
  }
  return null;
}

export const CONTRACT_TYPE_OPTIONS: { value: '' | ContractTypeCode; label: string }[] = [
  { value: '', label: 'Não informado' },
  { value: 'clt', label: 'CLT' },
  { value: 'mei', label: 'MEI' },
  { value: 'pj', label: 'PJ' },
  { value: 'other', label: 'Outro' },
];

export function contractTypeLabel(value?: string | null): string {
  return CONTRACT_TYPE_OPTIONS.find((option) => option.value === (value || ''))?.label || 'Não informado';
}
